import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BreadcrumbItem } from '../breadcrumb.component';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
  public breadcrumbs$: Observable<BreadcrumbItem[]> = this.breadcrumbsSubject.asObservable();

  setBreadcrumbs(items: BreadcrumbItem[]) {
    this.breadcrumbsSubject.next(items);
  }

  addBreadcrumb(item: BreadcrumbItem) {
    const currentBreadcrumbs = this.breadcrumbsSubject.value;
    this.breadcrumbsSubject.next([...currentBreadcrumbs, item]);
  }

  clear() {
    this.breadcrumbsSubject.next([]);
  }
}